import { useState, useEffect } from "react";
import Logo from "../../../components/logo/Logo";
import Toggle from "../../../components/toggle/Toggle";
import Input from "../../../components/form-input/Input";
import Btn from "../../../components/btn/create-account/Btn";
import useAuth from "../../../hooks/useAuth";
import { handleDisable } from "../../../utils/btn/handleDisable";
import { useNavigate } from "react-router-dom";
import IsLoading from "../../loading/IsLoading";
import { useDispatch } from "react-redux";
import { createSellerAccount } from "../../../slice/user/userSlice";
import req from "../../../axios/interceptedAxiosInstance";
import { successToast } from "../../../notification/notification";

export const Storename = ({ setLoading }) => {
  const dispatch = useDispatch();
  const { user } = useAuth();

  const [toggle, setToggle] = useState(false);
  const [username, setUsername] = useState("");

  useEffect(() => {
    if (toggle) {
      setUsername(user.data.user_name);
    } else {
      setUsername("");
    }
  }, [toggle, user.data.user_name]);

  const navigate = useNavigate();

  const reqBody = {
    full_name: username,
    full_address: "maitama",
    email: user.data.email,
    phone_number: "08135672267",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await req.post("user/seller", reqBody);
      const { data } = response;
      const { data: userData, message, status } = data;
      const { email, full_address, full_name, id, phone_number, user_id } =
        userData;
      const addToState = {
        status,
        email,
        full_address,
        full_name,
        id,
        phone_number,
        user_id,
        name: "Seller",
        code: "SELLER",
      };
      dispatch(createSellerAccount(addToState));
      successToast(message);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  const disable = handleDisable([username]);
  return (
    <div className="w-full">
      <div className="hidden lg:block">
        <Logo />
      </div>
      <h3 className="font-bold text-2xl mt-0 md:mt-10">
        Setup a seller account
      </h3>
      <div className="flex gap-3 items-center mt-2">
        <p className="font-normal text-base text-logoRed">
          Read our community guidelines
        </p>
        <div className="flex justify-center items-center rounded-full bg-logoRed h-4 w-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            fill="currentColor"
            className="bi bi-chevron-right text-white"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </div>
      </div>
      <div className="flex gap-3 items-center mt-8">
        <p>Use current username?</p>
        <Toggle isToggle={toggle} onToggleChange={setToggle} />
      </div>
      <div className="mt-10">
        <form>
          <Input
            type="text"
            placeholder="Username"
            value={username}
            onValueChange={setUsername}
            required={true}
            readonly={toggle}
          />
          <div className="flex gap-1">
            <div className="w-1/2 md:w-3/12">
              <Btn
                innerText="Next"
                active="bg-logoRed"
                inactive="bg-darkGrey"
                disable={disable}
                onclick={handleSubmit}
              />
            </div>
            <button
              className="text-logoRed w-1/2 md:w-3/12 mt-8 font-Lato font-bold h-12"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IsLoading(Storename, "Creating your store");
